import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FileUploadModule as FileUploadModule2 } from 'ng2-file-upload';
import { FileUploadComponent } from './FileUpload.component';

@NgModule({
    imports: [CommonModule, FileUploadModule2],
    declarations: [FileUploadComponent],
    exports: [FileUploadComponent],
    providers: []
})
export class FileUploadModule {}
